import { render } from "./BaseLoader.vue?vue&type=template&id=099760bc&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=099760bc&scoped=true&lang=css"

import exportComponent from "D:\\Mindscan\\online-quiz-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099760bc"]])

export default __exports__